"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MessageAdReadingPane_1 = require("./components/MessageAdReadingPane");
exports.MessageAdReadingPane = MessageAdReadingPane_1.default;
//# sourceMappingURL=lazyIndex.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/view/owa-mail-messagead-readingpane-view/lib/lazyIndex.js
// module id = 1914
// module chunks = 17